import { createFileRoute, Outlet } from '@tanstack/react-router'
import { pageTitle } from '@/lib/page-title'

export const Route = createFileRoute(
	'/(private)/bando/$residenceId/segnalazioni'
)({
	head: ({ match }) => ({
		meta: [
			{
				title: pageTitle(
					match.context.appLanguage,
					'admin-flags:page_title'
				)
			}
		]
	}),
	staticData: {
		breadcrumb: 'admin-flags:page_title'
	},
	component: () => <Outlet />
})
